import clsx from 'clsx';
import { FC, ReactNode } from 'react';

import { useIsMiddleSchoolView } from 'src/hooks/use-is-middle-school-view';

import './notification-card.scss';

interface Props {
  title: string;
  src?: string;
  imageComponent?: ReactNode;
}

const NotificationCard: FC<Props> = ({ title, src, imageComponent }) => {
  const isMiddleSchoolView = useIsMiddleSchoolView();

  return (
    <div
      className={clsx('notification-card', {
        'notification-card--middle-school': isMiddleSchoolView,
      })}
      role="alert"
    >
      {src && <img src={src} className="notification-card__img" alt="" />}
      {imageComponent}
      <div className="notification-card__text-container">
        <span className="notification-card__title">{title}</span>
      </div>
    </div>
  );
};

export default NotificationCard;
